import React from "react";
import styles from "./ArrowBounce.module.css"; // Create a new CSS module for this component

const ArrowBounce = () => {
  return (
    <div className={styles.arrowContainer}>
      <div className={styles.arrow}></div>
    </div>
  );
};

export default ArrowBounce;
